module.exports = __webpack_public_path__ + "static/media/Dollar.7d50d3d5.svg";